/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ResetPasswordComponent as ɵd} from './reset-password/reset-password.component';
export {UserFormComponent as ɵc} from './user-form/user-form.component';
export {UserComponent as ɵb} from './user.component';
export {declaration as ɵa} from './user.module';
export {UserRoutes as ɵe} from './user.routing';